import { MFEAddress } from '@interfaces/models/open-account-mfes/mfe-common.interfaces';
import { createSelector } from '@ngrx/store';
import { getMfePersonalAddressState } from '@store/reducers';

export const selectMfePersonalAddress = createSelector(
  getMfePersonalAddressState,
  (state) => state.personalAddress,
);

export const selectMfePersonalAddressMailingAddress = createSelector(
  selectMfePersonalAddress,
  (state) => state.mailingAddress,
);

export const selectMfePersonalAddressStreetAddress = createSelector(
  selectMfePersonalAddress,
  (state) => state.streetAddress,
);

export const selectMfePersonalAddressIsStreetAddressSame = createSelector(
  selectMfePersonalAddress,
  (state) => state.isStreetAddressSame,
);

export const selectMfePersonalAddressValidationStatus = createSelector(
  selectMfePersonalAddress,
  (state) => state.validationStatus,
);

export const selectMfePersonalAddressShowValidation = createSelector(
  selectMfePersonalAddress,
  (state) => state.showValidation,
);

export const selectMfePersonalAddressClientAddresses = createSelector(
  selectMfePersonalAddress,
  (state) => state.clientAddresses,
);

export const selectMfePersonalAddressIsClientAddressesProcessing = createSelector(
  selectMfePersonalAddress,
  (state) => state.isClientAddressesProcessing,
);

export const selectMfePersonalAddressIsClientAddressesLoaded = createSelector(
  selectMfePersonalAddress,
  (state) => state.isClientAddressesLoaded,
);

export const selectMfePersonalAddressMailingAddressDropdown = createSelector(
  selectMfePersonalAddress,
  (state) => state.mailingAddressDropdown,
);

export const selectMfePersonalAddressStreetAddressDropdown = createSelector(
  selectMfePersonalAddress,
  (state) => state.streetAddressDropdown,
);

export const selectMfePersonalAddressIsContinueConfirmed = createSelector(
  selectMfePersonalAddress,
  (state) => state.isContinueConfirmed,
);

/**
 * Returns an ordered list of distinct addresses for the client:
 * - Index 0: street (primary residence) address, when present
 * - Index 1: mailing address, only when the street address is also present,
 *   the addresses differ (isStreetAddressSame === false), and mailing has a
 *   populated street value
 */
export const selectMfePersonalAddresses = createSelector(
  selectMfePersonalAddressStreetAddress,
  selectMfePersonalAddressMailingAddress,
  selectMfePersonalAddressIsStreetAddressSame,
  (streetAddress, mailingAddress, isStreetAddressSame): MFEAddress[] => {
    const addresses: MFEAddress[] = [];
    if (!streetAddress?.street) {
      return addresses;
    }
    addresses.push(streetAddress);
    if (!isStreetAddressSame && mailingAddress?.street) {
      addresses.push(mailingAddress);
    }
    return addresses;
  },
);
